import ApiService from "service/Api";
import { RaffleWinnerPayloadTypes } from "utilities/types/RaffleWinner";

const RaffleService = {
  getAllRaffleOcrActivities: async (
    page: number,
    search: string,
    limit: number,
    filterCity: string
  ) => {
    const requestData = {
      method: "get",
      headers: {
        "Content-Type": "application/json; charset=utf-8",
      },
      params: {
        search: search,
        page: page,
        per_page: limit,
        filter_city: filterCity,
      },
      url: "/admin/raffles/ocr-activities",
    };

    try {
      const res = await ApiService.apiRequest(requestData);
      const data = res.data.data;

      return data;
    } catch (error) {
      throw error;
    }
  },

  getAllRaffles: async (
    page: number,
    search: string,
    limit: number,
    filterCity: string
  ) => {
    const requestData = {
      method: "get",
      headers: {
        "Content-Type": "application/json; charset=utf-8",
      },
      params: {
        search: search,
        page: page,
        per_page: limit,
        filter_city: filterCity,
      },
      url: "/admin/raffles",
    };

    try {
      const res = await ApiService.apiRequest(requestData);
      const data = res.data.data;

      return data;
    } catch (error) {
      throw error;
    }
  },

  getRaffleCode: async (cityId: string) => {
    const requestData = {
      method: "get",
      headers: {
        "Content-Type": "application/json; charset=utf-8",
      },
      params: {
        city_id: cityId,
      },
      url: "/admin/raffles/code",
    };

    try {
      const res = await ApiService.apiRequest(requestData);
      const data = res.data.data;

      return data;
    } catch (error) {
      throw error;
    }
  },

  getAllRaffleWinners: async (
    page: number,
    search: string,
    limit: number,
    filterCity: string
  ) => {
    const requestData = {
      method: "get",
      headers: {
        "Content-Type": "application/json; charset=utf-8",
      },
      params: {
        search: search,
        page: page,
        per_page: limit,
        filter_city: filterCity,
      },
      url: "/admin/raffles/winners",
    };

    try {
      const res = await ApiService.apiRequest(requestData);
      const data = res.data.data;

      return data;
    } catch (error) {
      throw error;
    }
  },

  storeRaffleWinner: async (payload: RaffleWinnerPayloadTypes) => {
    const { raffleCode, cityId } = payload;

    const requestData = {
      method: "post",
      headers: {
        "Content-Type": "application/json; multipart/form-data; charset=utf-8",
      },
      data: {
        raffle_code: raffleCode,
        city_id: cityId,
      },
      url: "admin/raffles/winners",
    };

    try {
      const res = await ApiService.apiRequest(requestData);
      const data = res.data.data;

      return data;
    } catch (error) {
      throw error;
    }
  },

  getAllRaffleCities: async () => {
    const requestData = {
      method: "get",
      headers: {
        "Content-Type": "application/json; charset=utf-8",
      },
      url: "/admin/raffles/cities",
    };

    try {
      const res = await ApiService.apiRequest(requestData);
      const data = res.data.data;

      return data;
    } catch (error) {
      throw error;
    }
  },
};

export default RaffleService;
